import { motion, AnimatePresence } from "framer-motion";
import DropdownMenuItem from "../Atoms/DropdownMenuItem";
import styles from "../../Styles/DropdownMenu.module.css";

const showMenu = {
  enter: {
    opacity: 1,
    y: 0,
    display: "block",
  },
  exit: {
    y: -6,
    opacity: 0,
    transition: {
      duration: 0.15,
    },
    transitionEnd: {
      display: "none",
    },
  },
};

const DropdownMenu = ({ option, toggle, show, OPTIONS }) => {
  const selectedHandler = (value) => {
    option(value);
    toggle();
  };
  const showHandler = () => {
    toggle();
  };

  return (
    <motion.div className={styles.dropdown}>
      <div onClick={showHandler} className={styles.dropdown_menu}>
        <p>Select filter</p>
      </div>
      <AnimatePresence>
        <motion.div
          variants={showMenu}
          initial="exit"
          animate={show ? "enter" : "exit"}
          className={styles.dropdown_backdrop}
        >
          {OPTIONS.map((option, index) => (
            <DropdownMenuItem
              key={index}
              option={option}
              selectedOption={selectedHandler}
            />
          ))}
        </motion.div>
      </AnimatePresence>
    </motion.div>
  );
};

export default DropdownMenu;

/*
        <AnimatePresence>
          <motion.div
            variants={showMenu}
            initial="exit"
            animate={show ? "enter" : "exit"}
            className={`${styles.dropdown_backdrop} ${styles.dropdown}`}
          >
            {OPTIONS.map((option, index) => (
              <DropdownMenuItem
                key={index}
                option={option}
                selectedOption={selectedHandler}
              />
            ))}
          </motion.div>
        </AnimatePresence>
*/
